import React, { useEffect, useState } from "react";

function Modal({ open, children, toggle, headerTitle, onClose }) {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      setIsVisible(true);
      // Small delay to ensure smooth animation
      setTimeout(() => setIsAnimating(true), 10);
    } else {
      setIsAnimating(false);
      // Wait for animation to complete before hiding
      setTimeout(() => {
        setIsVisible(false);
        document.body.style.overflow = "visible";
      }, 300);
    }
  }, [open]);

  useEffect(() => {
    if (!open) {
      if (onClose) {
        onClose(false);
      }
    }
  }, [open]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      toggle(false);
    }
  };

  return (
    <>
      {isVisible ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Animated Backdrop */}
          <div 
            className={`absolute inset-0 bg-black/60 backdrop-blur-sm transition-all duration-300 ease-out ${
              isAnimating ? 'opacity-100' : 'opacity-0'
            }`}
            onClick={handleOverlayClick}
          />
          
          {/* Modal Container */}
          <div 
            className={`relative w-full max-w-2xl max-h-[90vh] bg-white rounded-2xl shadow-2xl transform transition-all duration-300 ease-out ${
              isAnimating 
                ? 'scale-100 opacity-100 translate-y-0' 
                : 'scale-95 opacity-0 translate-y-4'
            }`}
          >
            {/* Header with Gradient Background */}
            <div className="relative bg-gradient-to-r from-blue-600 via-blue-600 to-blue-600 rounded-t-2xl p-6">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600/90 via-blue-600/90 to-blue-600/90 rounded-t-2xl"></div>
              <div className="relative flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h2 className="text-xl font-bold text-white">
                    {headerTitle || "Modal"}
                  </h2>
                </div>
                
                {/* Beautiful Close Button */}
                <button
                  onClick={() => toggle(false)}
                  className="group relative w-10 h-10 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center hover:bg-white/30 transition-all duration-200 hover:scale-110"
                >
                  <svg 
                    className="w-5 h-5 text-white group-hover:rotate-90 transition-transform duration-200" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  
                  {/* Hover Effect Ring */}
                  <div className="absolute inset-0 rounded-xl border-2 border-white/0 group-hover:border-white/30 transition-all duration-200"></div>
                </button>
              </div>
              
              {/* Decorative Elements */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full translate-y-12 -translate-x-12"></div>
            </div>
            
            {/* Modal Body with Scroll */}
            <div className="max-h-[calc(90vh-120px)] overflow-y-auto">
              {children}
            </div>
            
            {/* Bottom Gradient Border */}
            {/* <div className="h-1 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 rounded-b-2xl"></div> */}
          </div>
        </div>
      ) : null}
    </>
  );
}

export default Modal;
